import { compareHelpers } from '@approvalmax/utils';

export const getCompaniesIdsString = (companiesIds: string[]) =>
    companiesIds.toSorted(compareHelpers.stringComparator2Asc).join('.');

export const isObjectWithStringValues = (obj: any): obj is Record<string, string> => {
    return Object.values(obj).every((value) => typeof value === 'string');
};
